import { clone, equals } from 'ramda';

import { type TGeoValue } from '../api-models/common/json_query';

import { setGeo } from './helpers';
import { type NonEmptyArray, type TJsonQuery } from './types';

export function selectGeo(jsonQuery: TJsonQuery): (...geoValues: NonEmptyArray<TGeoValue>) => TJsonQuery {
  return (...geoValues) => {
    const nextGeo = (jsonQuery.geo && clone(jsonQuery.geo.value)) || [];

    const addedGeoValues = geoValues.filter(v => !nextGeo.some(g => equals(v, g)));

    return setGeo()(jsonQuery)([...nextGeo, ...addedGeoValues]);
  };
}
